import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box, Container } from '@chakra-ui/react';
import Navbar from './Navbar';
import Footer from './Footer';

/**
 * Main layout component for public pages
 * Includes the main navigation, content area, and footer
 */
const Layout = () => {
  const location = useLocation();
  const hideNavbar = location.pathname === '/' || location.pathname === '/project-closed';

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      {!hideNavbar && <Navbar />}
      <Box as="main" flex="1" py={8}>
        <Container maxW="container.xl">
          <Outlet />
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;
